import { formatDistance } from 'date-fns'
import Avatar from './avatar'
import { FaVideo, FaSpinner } from 'react-icons/fa'
import { VscCallOutgoing } from 'react-icons/vsc'
import {
  MdFilePresent,
  MdArchive,
  MdOutlineAddIcCall,
  MdOutlineArrowCircleLeft,
  MdUnarchive,
  MdSchedule,
  MdAssignmentInd,
} from 'react-icons/md'

import { useState,  useEffect } from 'react' // Added useEffect for cleanup
import { toastModal, toastError } from '../../../utils/helpers/methods'
import { SENDBIRD_INFO } from '../../../utils/helpers/constant'
import removeDataOnAssignedChat from '../../../utils/services/archive'
import { GetPatientTag } from '../../../utils/services/patient'
import { Badge, Button, Modal, Popover, Tooltip } from 'flowbite-react'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { toogleFilter, unToogleFilter } from '../../../redux/slices/chat'
import { useDispatch, useSelector } from 'react-redux'
import { locationUIInfo } from '../CityCode'
import { assignToMe } from '../../../utils/services/assign.service'
import { updateChatAssignment } from '../../../utils/services/updateChatAssignment'

const ChanneLItemPreview = ({
  currentUser,
  item,
  onClick,
  isMoveToPractice,
  moveToPractice,
  activeTab,
  scheduledMessageList
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  
  const [processingAction, setProcessingAction] = useState(null); // 'move', 'archive', 'unarchive', 'assign'

  const [isMounted, setIsMounted] = useState(true);
  useEffect(() => {
      return () => {
          setIsMounted(false);
      };
  }, []);

  const safeSetProcessingAction = (val) => {
      if(isMounted) setProcessingAction(val);
  }


  const gotToChatSpace = (e) => {
    dispatch(unToogleFilter())
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    onClick && onClick(item)
  }
  const { userInfo} = useSelector(
    (state) => state.auth
  )
  const [patientStatusInfo, setPatientStatusInfo] = useState()
  const [openModal, setOpenModal] = useState(false);

  const getPopupInfo = async(channel,e) =>{
    if (channel?.userId?.toLowerCase().startsWith('pa')) {
    const filteredPA = channel?.userId?.slice(2); 
    await GetPatientTag(filteredPA).then((response)=>{
    setPatientStatusInfo(response?.data?.data)});
    setOpenModal(true);
    }
  }

  const viewPatient = async ()=>{
    setOpenModal(false);
    setPatientStatusInfo(null)
    if(patientStatusInfo){
    navigate('/patientDetails/'+patientStatusInfo?.patient_id)
    }
  }

  const closePopup = (e)=>{
    e.preventDefault()
    e.stopPropagation()
    setOpenModal(false);
    setPatientStatusInfo(null)
  }

  const getChannelInfo = () => {
    const { members, name } = item
    switch (name) {
      case 'Admin':
        return { name: 'ConnectCare Team' }
      case 'Teams': {
        const filtered = members.filter((x) => x.userId !== currentUser?.userId)
        const memName = filtered.map((item, index) =>
          filtered.length - 1 === index ? item.nickname : item.nickname + ','
        )

        const status = filtered[0]?.connectionStatus
        return { name: memName[0], status: status }
      }
      case 'DPCDoctor':
        const filteredPA = members.filter((x) => x.userId.slice(0, 2) === 'PA')
        const memName = filteredPA.map((item, index) =>
          filteredPA.length - 1 === index ? item.nickname : item.nickname + ','
        )
        const memId = filteredPA.map((item, index) =>
        filteredPA.length - 1 === index ? item.userId : item.userId + ','
      )
        return { name: memName[0], status: filteredPA[0]?.connectionStatus ,userId:memId[0]}
      default:
        return { name: null }
    }
  }

  const onClickMoveToDefault = (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation();

    if(processingAction) return;
    setProcessingAction('move');

    setTimeout(() => {
        try {
            updateChatAssignBackend(2);
            moveToPractice(item)
        } catch (error) {
            console.error(error);
            safeSetProcessingAction(null);
        }
    }, 1000);
  }

  const channelInfo = getChannelInfo()

  const filterArray = item?.members?.filter(
    (member) => member?.metaData?.patient !== 'false'
  )
  const [showArchive, setShowArchive] = useState(true)

  const [showUnArchive, setShowUnArchive] = useState(false)


  const updateChatAssignBackend = (status) => {
    const channelUrl = item?.channelUrl || item?.url;
    const patient = item?.members?.filter((x) => x.userId.startsWith("PA"));
    const patientId = patient?.[0]?.userId || null;
    updateChatAssignment(dispatch, {
      channelUrl,
      userInfo,
      patientId,
      status,
    });
  }
  const archiveChat = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    
    if (processingAction) return;
    setProcessingAction('archive');

    const prevShowArchive = showArchive;
    const prevShowUnArchive = showUnArchive;
    setShowArchive(false)
    setShowUnArchive(true)

    setTimeout(async () => {
        try {
            if (activeTab == 'tab1') {
            updateChatAssignBackend(3);
            removeDataOnAssignedChat(item,()=>{
                toastModal('Archived Successfully');
                safeSetProcessingAction(null);
            },activeTab,currentUser) 
            } else if(activeTab == 'tab0'){
            var hideParams = {
                hidePreviousMessages: false,
                allowAutoUnhide: true,
            }
            await item.hide(hideParams).then((res) => {
                toastModal('Archived Successfully')
                safeSetProcessingAction(null);
            })
            }
        } catch (error) {
            setShowArchive(prevShowArchive);
            setShowUnArchive(prevShowUnArchive);
            safeSetProcessingAction(null);
            toastError(error)
        }
    }, 1000);
  }

  const unArchiveChat = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (processingAction) return;
    setProcessingAction('unarchive');

    const prevShowArchive = showArchive;
    const prevShowUnArchive = showUnArchive;
    setShowArchive(true);
    setShowUnArchive(false);
    
    setTimeout(async () => {
        try {
            await item.unhide().then((res) => {
                toastModal('UnArchived Successfully')
                safeSetProcessingAction(null);
            })
        } catch (error) {
            setShowArchive(prevShowArchive);
            setShowUnArchive(prevShowUnArchive);
            safeSetProcessingAction(null);
            toastError(error)
        }
    }, 1000);
  }

  const assignChat = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (processingAction) return;
    setProcessingAction('assign');

    setTimeout(() => {
        try {
            assignToMe(item,item,userInfo.doctor_login.sendbird_user_id,userInfo,1,dispatch,()=>{
                toastModal('Assigned Successfully')
                safeSetProcessingAction(null);
            })
        } catch (error) {
            safeSetProcessingAction(null);
            console.error(error);
        }
    }, 1000);
  }

  const toogleToFilter =()=>{
     dispatch(toogleFilter())
     onClick && onClick(item)
  }
 
  const parseData = (x) => {
    if (!x || !x.data) return true;
    try {
      const parsed = JSON.parse(x.data);
      return parsed?.AssignedTo !== currentUser?.userId || parsed?.ArchivedBy !== currentUser?.userId;
    } catch (e) {
      return x.data !== currentUser?.userId;
    }
  };
  
  const parseDataTitle = (x) => {
    if (!x || !x.data) return null;
  
    try {
      const parsed = JSON.parse(x.data);
      const assignedTo = parsed?.AssignedTo;
      const archivedBy = parsed?.ArchivedBy;
  
      return (
        <>
          {archivedBy && archivedBy !== currentUser?.userId && x.hiddenState === "hidden_allow_auto_unhide" && (
            <p className='text-sm text-orange-900 truncate dark:text-gray-400'>
              Archived By {x.members.find(m => m.userId == archivedBy)?.nickname}
            </p>
          )}
          {assignedTo && assignedTo !== currentUser?.userId && (
            <p className='text-sm text-orange-900 truncate dark:text-gray-400'>
              Assigned to {x.members.find(m => m.userId == assignedTo)?.nickname}
            </p>
          )}
        </>
      );
    } catch (e) {
      // Plain string fallback (old format)
      return (
        x.data !== currentUser?.userId && (
          <p className='text-sm text-orange-900 truncate dark:text-gray-400'>
            Assigned to {x.members.find(m => m.userId === x.data)?.nickname}
          </p>
        )
      );
    }
  };
  
  return (
    <ul
      role='list'
      className='divide-y divide-gray-200 dark:divide-gray-700 '
      >
      <li className='py-3 first:pt-0'>
        <div className='flex items-center flex-wrap sm:flex-nowrap justify-between rounded-md hover:bg-gray-200 px-2 py-3 w-full gap-3'>
        <div className='flex items-start lg:items-center space-x-4 w-full sm:w-[auto]'>
          <div className='flex-shrink-0'>
            {filterArray.length === 0 ? (
              <Avatar
                onClick={(e)=>getPopupInfo(channelInfo,e)}
                showStatus={true}
                fname={channelInfo.name}
                lname=''
                image={
                  item?._name === 'Admin'
                    ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSC-Is9vPh4AgDCULO33AmoIpSvXcaJ51VrRZQUDXxl0YjDDAq94jciUm7zt7SB4OD5UhA&usqp=CAU'
                    : item?.coverUrl
                }
                status={channelInfo.status}
              />
            ) : (
              <Avatar
              showStatus={true}
              fname={
                !filterArray[0]?.plainProfileUrl
                  ? filterArray[0].nickname
                  : channelInfo.name
              }
              lname=''
              image={
                item?._name === 'Admin'
                  ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSC-Is9vPh4AgDCULO33AmoIpSvXcaJ51VrRZQUDXxl0YjDDAq94jciUm7zt7SB4OD5UhA&usqp=CAU'
                  : !filterArray[0]?.plainProfileUrl
                    ? ''
                    : filterArray[0]?.plainProfileUrl
              }
              status={channelInfo.status}
              onClick={(e) => getPopupInfo(channelInfo,e)}
            />              
            )}
          </div>
          <div className='flex-1 min-w-0' onClick={gotToChatSpace}>
            <p className='text-sm font-medium text-gray-900 truncate dark:text-white'>
              {channelInfo.name}
            </p>
            {/* <div className="flex gap-4">
              {item?.lastMessage?.customType === 'VIDEO_CALL' ? (
                item?.creator?.userId === currentUser?.userId ? <div className="flex items-center text-green-500">
                  <FaVideo className="mr-2" /> Call
                </div>:<p>{item?.creator?.nickname}</p>
              ) : (
                <p className="text-sm">
                  {((item?.lastMessage?.message)?.length > 100) ? `${(item?.lastMessage?.message)?.slice(0, 100) + '   ........'}` : item?.lastMessage?.message}·
                </p>
              )}

              <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                {formatDistance(new Date(item?.lastMessage?.createdAt), new Date(), { addSuffix: true })}
              </p>
            </div> */}
            <div className='flex flex-wrap gap-x-4 gap-y-1'>
              {/* {(item?.lastMessage?.customType === 'VIDEO_CALL' )&& (
                item?.creator?.userId === currentUser?.userId ? <div className="flex items-center text-green-500">
                  <FaVideo className="mr-2" /> Call
                </div>:<p>{item?.creator?.nickname}</p>
              )} */}
              {(item?.lastMessage?.messageType!=="file"&&item?.lastMessage?.customType!= "VIDEO_CALL") && <p className="text-sm">{((item?.lastMessage?.message)?.length > 100)?`${(item?.lastMessage?.message)?.slice(0,100)+'   ........'}`:item?.lastMessage?.message} </p>}
              {item?.lastMessage?.messageType=="file" && <p className="flex text-sm  text-gray-900 "><MdFilePresent className='m-1' />{item?.lastMessage?.name} </p>} 
              {item?.lastMessage?.customType== "VIDEO_CALL"&& <p className="flex text-sm text-everglade-900 "><VscCallOutgoing className='m-1'/>Call</p>} 
              <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                {item?.lastMessage?.createdAt && formatDistance(new Date(item?.lastMessage?.createdAt), new Date(), { addSuffix: true })}
              </p>
              {/* {item?.data && !isMoveToPractice && (
                <p className='text-sm text-orange-900 truncate dark:text-gray-400'>
                  Assigned to{' '}
                  {item.members.find((x) => x.userId == item.data)?.nickname}
                </p>
              )} */}
              
              {item?.data && parseData(item) && parseDataTitle(item)}
            </div>
          </div>
          
          {item.unreadMessageCount > 0 && (
            <div className='inline-flex items-center text-base font-semibold text-gray-900 dark:text-white'>
              <div className=' -top-2 -right-2 bg-red-600 text-white rounded-full px-2 py-1 text-xs'>
                {item?.unreadMessageCount}
              </div>
            </div>
          )}
        </div>
      <div className='flex flex-row items-center gap-3 ml-[64px] sm:ml-0'>
        {isMoveToPractice && (
            <Tooltip content="Move chat to practice channel">
            <span
              onClick={onClickMoveToDefault}
              className={`rounded-md font-bold mr-2 inline-flex min-w-0 hover:bg-everglade-400 hover:cursor-pointer text-white bg-everglade-600 p-2 ${processingAction ? 'opacity-70 cursor-wait' : ''}`}
            >
              {processingAction === 'move' ? (
                 <div className="flex items-center gap-2">
                   <FaSpinner className="animate-spin text-white" size={20} />
                   <span>Moving...</span>
                 </div>
              ) : 'Move to Practice channel'}
            </span>
            </Tooltip>
          )}
      {activeTab == 'tab2' && (
        processingAction === 'unarchive' ? (
           <FaSpinner className="animate-spin text-everglade-600" size={35} />
        ) : (
          <Tooltip content="Unarchive Chat">
            <MdUnarchive
                onClick={unArchiveChat}
                className={`text-everglade-600  hover:text-everglade-400 cursor-pointer ${processingAction ? 'opacity-50 cursor-wait' : ''}`}
                size={35}
            />
          </Tooltip>
        )
      )}
      {(activeTab == 'tab0' || activeTab == 'tab1') && (
        processingAction === 'archive' ? (
           <FaSpinner className="animate-spin text-everglade-600" size={35} />
        ) : (
            <Tooltip content="Archive Chat">
                <MdArchive
                    onClick={archiveChat}
                    className={`text-everglade-600 hover:text-everglade-400 cursor-pointer ${
                    !showArchive && 'hidden'
                    } ${processingAction ? 'opacity-50 cursor-wait' : ''}`}
                    size={35}
                />
            </Tooltip>
        )
      )}
      
      {(activeTab == 'tab0' || activeTab == 'tab2') && item.name=='DPCDoctor' && (
         processingAction === 'assign' ? (
           <FaSpinner className="animate-spin text-everglade-600" size={30} />
        ) : (
            <Tooltip content="Assign to me">
                <MdAssignmentInd className={`text-everglade-600 hover:text-everglade-400 cursor-pointer ${processingAction ? 'opacity-50 cursor-wait' : ''}`}
                    size={30}
                    onClick={assignChat}></MdAssignmentInd>
            </Tooltip>
        )
      )}

         {scheduledMessageList.find(x=>x.channelUrl==item.url)  &&
         <Tooltip content="Scheduled Messages">
            <MdSchedule     
            className={`text-everglade-600 hover:text-everglade-400 cursor-pointer `}
            size={30}
            onClick={toogleToFilter}
            />
        </Tooltip>
         }
        <Modal className="custom-modal-overlay custom-chat-modal" show={openModal} size="md" position="center" onClose={(e) => closePopup(e)} dismissible>
        <Modal.Header className='p-5'>Chat Info</Modal.Header>
        <Modal.Body className="p-5 max-h-[50vh] overflow-y-auto">
            <div className="flex mb-4 flex-row items-center">
              <Avatar
                className={"flex justify-center"}
                showStatus={true}
                fname={
                  !filterArray[0]?.plainProfileUrl
                    ? filterArray[0]?.nickname
                    : channelInfo?.name
                }
                lname=""
                image={
                  item?._name === "Admin"
                    ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSC-Is9vPh4AgDCULO33AmoIpSvXcaJ51VrRZQUDXxl0YjDDAq94jciUm7zt7SB4OD5UhA&usqp=CAU"
                    : !filterArray[0]?.plainProfileUrl
                      ? ""
                      : filterArray[0]?.plainProfileUrl
                }
                status={channelInfo.status}
                onClick={() => getPopupInfo(channelInfo)}
              />
              <h3 className="text-lg font-bold text-gray-500 dark:text-gray-400 ml-4">
                {patientStatusInfo &&
                  patientStatusInfo?.first_name + " " + patientStatusInfo?.last_name}
              </h3>
            </div>

            <div className='flex mb-4 flex-row gap-3 flex-wrap'>
              {locationUIInfo(patientStatusInfo)}
              {patientStatusInfo?.patients?.is_vip == 1 && <Icon icon="quill:vip" fontSize={40} color='#ffbf00'></Icon>}
              {patientStatusInfo?.patients && <Badge className="break-all" size={40} color={(patientStatusInfo?.patients.deleted_at == null || patientStatusInfo?.patients.deleted_at == '') ? 'success' : 'failure'}>{(patientStatusInfo?.patients.deleted_at == null || patientStatusInfo?.patients.deleted_at == '') ? 'Active' : 'InActive'}</Badge>}
              {patientStatusInfo?.location_group?.group_name && <Badge className="break-all" color="blue" size={40}>{patientStatusInfo?.location_group?.group_name}</Badge>}
            </div>          
        </Modal.Body>
        <Modal.Footer className='p-5 justify-center'>
          <div className="flex justify-center gap-4">
            <Button
            type="button"
            className="rounded-lg bg-blue-700 text-xs font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            onClick={() => viewPatient()}
          >
            View Details
          </Button>
            </div>
          </Modal.Footer>
      </Modal>
      </div>
      </div>
      </li>
    </ul>
  )
}
export default ChanneLItemPreview